<div class="preview-container">
  <mat-icon class="close-button" (click)="dialogRef.close()" svgIcon="cancel" matTooltip="Close"></mat-icon>

  @if (isVideoPreview) {
    @if (item.PlaylistItemLinks[0].videoContent; as content) {
      <video autoplay controls loop [muted]="true" controlsList="nofullscreen nodownload">
        <source [src]="content" [type]="appConst.VIDEO_SOURCE_TYPE" />
      </video>
    }
    @else {
      <div class="d-flex align-items-center justify-content-center h-100">
        <app-loader></app-loader>
      </div>
    }
  }
  @else {
    <img class="image-preview" [src]="item.PlaylistItemLinks[0]?.content">
  }
</div>

